import { PaginateProvider } from 'contexts/paginate';
import Container from 'components/layout/container';
import TopMenu from 'components/layout/top_menu';
import InvitationsContainer from 'components/space/invitations_container';
import SpaceContainer from 'components/space/index_container';

const Spaces = () => (
  <Container>
    <TopMenu />
    <Container>
      <InvitationsContainer />
      <PaginateProvider>
        <SpaceContainer />
      </PaginateProvider>
    </Container>
  </Container>
);

export default Spaces;
